<template>
  <transition name="fade" :mode="mode">
    <slot></slot>
  </transition>
</template>
<script>
export default {
  props: ["mode"],
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: all 125ms ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fade-leave, .fade-enter-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 1;
}
</style>